export const convertBreakpointToNumber = (breakpoint: string) => +breakpoint.replaceAll('px', '')
